import React from 'react';

export default function IconFullscreen() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
        d="M28 5C28 4.44771 27.5523 4 27 4H26H19C18.4477 4 18 4.44771 18 5C18 5.55229 18.4477 6 19 6H26V13C26 13.5523 26.4477 14 27 14C27.5523 14 28 13.5523 28 13V6V5Z"
        fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd"
        d="M28 27C28 27.5523 27.5523 28 27 28H26H19C18.4477 28 18 27.5523 18 27C18 26.4477 18.4477 26 19 26H26V19C26 18.4477 26.4477 18 27 18C27.5523 18 28 18.4477 28 19V26V27Z"
        fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd"
        d="M4 5C4 4.44771 4.44772 4 5 4H6H13C13.5523 4 14 4.44771 14 5C14 5.55229 13.5523 6 13 6H6V13C6 13.5523 5.55228 14 5 14C4.44772 14 4 13.5523 4 13V6V5Z"
        fill="currentColor" />
      <path fillRule="evenodd" clipRule="evenodd"
        d="M4 27C4 27.5523 4.44772 28 5 28H6H13C13.5523 28 14 27.5523 14 27C14 26.4477 13.5523 26 13 26H6V19C6 18.4477 5.55228 18 5 18C4.44772 18 4 18.4477 4 19V26V27Z"
        fill="currentColor" />
    </svg>

  );
}
